import { Component, OnInit } from '@angular/core';
import { DetalleVentaService, MercaderiaService } from 'src/app/service/index.service';
import * as moment from 'moment';
import { Mercaderia } from 'src/app/model/index.model';
import { ChartConfiguration, ChartData, ChartDataset, ChartType } from 'chart.js';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reporte-producto',
  templateUrl: './reporte-producto.component.html',
  styleUrls: ['./reporte-producto.component.css'],
  providers: [DatePipe]
})
export class ReporteProductoComponent implements OnInit {
  fechade: any;
  fechaha: any;
  search: String = "";
  loading: boolean = false;
  items: any[] = [];
  stockActual: number = 0; // opcional, si querés mostrar stock final

  item: Mercaderia = new Mercaderia()
  fecha = new Date();

  constructor(private wsdl: MercaderiaService, private datePipe: DatePipe,) { }

  ngOnInit() {
  }

  parseDate(fecha) {
    if (moment(fecha).isValid()) {
      return moment(fecha);
    }
  }

  async getList() {
    try {
      this.loading = true;
      this.fechade = moment(this.fechade).format("YYYY-MM-DD") + " 00:00:00";
      this.fechaha = moment(this.fechaha).format("YYYY-MM-DD") + " 23:59:00";

      let data = await this.wsdl.getReporteStockId(this.fechade, this.fechaha, this.search).then();

      let res = JSON.parse(JSON.stringify(data));
      if (res.code == 200) {
        this.items = res.data;

        this.actualizarGrafico()
      }
    } catch (error) {

    } finally {
      this.loading = false;
    }
  }

  // para exportar a excel
  /**
  * Exporta una tabla HTML a archivo Excel (.xlsx)
  * @param tableID ID del elemento <table> que querés exportar
  * @param filename Nombre del archivo (sin extensión)
  */
  exportTableToExcel(tableID: string, filename: string = 'datos_exportados'): void {
    const table = document.getElementById(tableID);
    if (!table) {
      console.error(`No se encontró la tabla con ID: ${tableID}`);
      return;
    }

    // Limpiamos un poco el HTML (opcional pero recomendado)
    const tableHTML = table.outerHTML
      .replace(/ /g, '%20')           // espacios → %20 para URL
      .replace(/<a[^>]*>|<\/a>/g, ''); // quitamos links si hay (evita problemas)

    // Creamos el Blob con MIME tipo Excel
    const blob = new Blob(['\ufeff', tableHTML], {
      type: 'application/vnd.ms-excel;charset=utf-8;'
    });

    // Creamos URL temporal
    const url = window.URL.createObjectURL(blob);

    // Creamos link invisible para descargar
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = `${filename}.xls`;  // .xls es más compatible que .xlsx para HTML simple

    // Agregamos al DOM, clickeamos y limpiamos
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Limpieza (importante para evitar memory leaks)
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  }
  itemSel(event: Mercaderia) {
    if (event.id !== undefined) {
      this.item = event
      this.search = "" + event.id;
    }

  }

  public lineChartDatasets: ChartDataset<'line'>[] = [];  // ← solo el array de datasets

  public lineChartLabels: string[] = [];

  // Opcional: mantén esto para las opciones globales
  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' as const },
      tooltip: { mode: 'index', intersect: false }
    },
    scales: {
      y: {
        beginAtZero: false,
        title: { display: true, text: 'Stock' }
      },
      x: {
        title: { display: true, text: 'Fecha / Movimiento' }
      }
    }
  };

  public lineChartType: ChartType = 'line';

  // Cuando cargas los items (después de getList())
  actualizarGrafico() {

    if (this.items.length < 5) {
      this.lineChartDatasets = [];
      this.lineChartLabels = [];
      return;
    }

    const movimientosOrdenados = [...this.items].sort((a, b) =>
      new Date(a.fecha).getTime() - new Date(b.fecha).getTime()
    );

    console.log("llego")

    const labels: string[] = [];
    const stockAcumulado: number[] = [];
    let stockActual = 0; // ← ajusta si tienes stock inicial

    movimientosOrdenados.forEach(mov => {
      console.log("llego2")
      labels.push(this.datePipe.transform(mov.fecha, 'dd-MM HH:mm') || 'Sin fecha');
      console.log("llego3")
      const delta = mov.tipo === 'Ingreso' ? mov.cantidad : -mov.cantidad;
      stockActual += delta;
      stockAcumulado.push(stockActual);
    });

    this.lineChartLabels = labels;

    this.lineChartDatasets = [
      {
        data: stockAcumulado,
        label: 'Evolución del Stock',
        borderColor: '#0d6efd',
        backgroundColor: 'rgba(13, 110, 253, 0.2)',
        fill: true,
        tension: 0.3,
        pointBackgroundColor: '#0d6efd',
        pointBorderColor: '#fff',
        pointRadius: 5
      }
    ];
    console.log("llego3")
  }
}
